import { useLocation } from "react-router-dom";
import { PRIVATE_ROUTE } from "../../route.constants";
import {
  IconDashboard,
  IconTemplate,
  IconSettings,
  IconBusinessInfo,
  IconTerms,
  // IconPayment,
  // IconDelivery,
  IconProducts,
  IconCategories,
  IconCatalogue,
  IconOrders,
  IconNoteSticky,
  IconInventoryReport,
  IconUser,
  IconAdminReport,
  IconReports,
  IconAdmins,
  IconBrand,
 IconManualPayment,
 SwitchHorizontal,
 IconPaymentReport,
 IconCustomerReport,
 IconOrderReport,
 IconIncomeReport,
 IconWithdrawReport
} from "@assets";
import { ORDER_STATUS } from "../../constants";
import { DatabaseOutlined, LineChartOutlined } from "@ant-design/icons";
import { IconAddPackage, IconItemProfit, IconLock, IconOptionEdit, IconProfitIcon } from "../../assets/icons";
import { RecivingAccount } from "../../assets/PaymentIcon";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import api from "../../api/api";
import styled, { keyframes } from "styled-components";
import { message } from "antd";
import { orderCount } from "../../utils/atom";
import { useTranslation } from "react-i18next";


const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 59, 59, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 59, 59, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 59, 59, 0);
  }
`;

const Badge = styled.span`
  width: 21px;
  height: 21px;
  padding: 0 5px;
  border-radius: 50%;
  background: #ff3b3b;
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${pulse} 1.5s infinite;
`;

const BadgeWrapper = styled.div`
  position: relative;
  display: flex;
  width:100%;
  align-items:center;
  gap:10px;
`;

const useOptions = () => {
  const { pathname } = useLocation();
  const [, , path1, path2] = pathname.split("/");

   const [data, setData] = useState();
  const [deliCheck, setDeliCheck] = useState();

  const adminData = localStorage.getItem("admin");
  const admin = adminData ? JSON.parse(adminData) : null;
  const role = admin?.role;

  const {
    DASHBOARD,
    TEMPLATE,
    TEMPLATE_MGNT,
    SETTINGS,
    BUSINESS_INFORMATION,
    TERMS_CONDITIONS,
    // PAYMENT_METHODS,
    // DELIVERY_AREA,
    DATA_MGNT,
    PRODUCTS,
    CATEGORIES,
    CATALOGUES,
    ORDER_MGNT,
    ORDERS,
    STOCK_MGNT,
    STOCK_INVENTORY_REPORT,
    USER_MANAGEMENT,
    REPORTS,
    ADMIN_REPORT,
    USER_REPORT,
    INCOME_REPORT,
    ORDER_REPORT,
    ADMINS,
    BRAND,
    PAYMENT_TERMS_CONDITIONS,
    CUSTOMER_LOGIN_METHODS,
    CANCEL_REASON,
    // DELIVERY_AREA_TERMS,
     WELCOME_MESSAGE,
    OPT_USAGE_REPORT,
    PAYMENT,
    PAYMENTAUTO,
    PAYMENTMANUAL,
    EXCHANGERATE,
    MAINTENANCE,
    RECIVINGACCOUNT,
    PAYMENTREPORT,
    WITHDRAWREPORTS,
    SLIDER_CONFIG,
    STEPUP_STORE,
    PROFIT_REPORT,
    ITEMS_PROFIT,
    ADD_PACKAGE,
    PRODUCT_OPTIONS,
  } = PRIVATE_ROUTE;

  const [orderStatus,] = useAtom(orderCount);
    const [checkInit, setCheckInit] = useState();

    const {t}  = useTranslation();

    const getCheckInit = () => {
        api
          .getCheckSubDomain()
          .then(({ data }) => {
            setCheckInit(data);
          })
          .catch((error) => {
           console.log(error)
          });
      };
  

  const getOrderCounts = () => {
    api
      .getOrderCounts()
      .then((res) => {
        setData(res.data || [])
      })
      .catch((err) => message.error(err))
  };

  useEffect(() => {
    getOrderCounts();
    getCheckInit();
  }, [orderStatus]);

  const MenuLabelWithBadge = ({ label, count }) => {
  return (
    <BadgeWrapper>
      {label}
      {count >= 0 && <Badge>{count}</Badge>}
    </BadgeWrapper>
  );
};

  const allOptions = [
    {
      key: DASHBOARD,
      icon: <IconDashboard />,
      label: t('menu_1'),
    },
    {
      key: ORDER_MGNT,
      label: t('menu_2'),
      icon: <IconOrders />,
      children: [
        {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.PENDING}`,
          // icon: <IconOrders />,
          label: (
            <MenuLabelWithBadge
              label= {t('menu_36')}
              count={data?.pendingCount}
            />
          ),
        },
        {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.UNPAID}`,
          // icon: <IconOrders />,
          label: ( <MenuLabelWithBadge
              label={t('menu_37')}
              count={data?.unpaidCount}
            />),
        },
        {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.CONFIRMED}`,
          // icon: <IconOrders />,
          label: (<MenuLabelWithBadge
          label={t('menu_38')}
          count={data?.confirmedCount}
        />),
        },
        {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.COMPLETED}`,
          // icon: <IconOrders />,
          label: ( <MenuLabelWithBadge
          label={t('menu_39')}
          count={data?.completedCount}
        />),
        },
        {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.CANCELLED}`,
          // icon: <IconOrders />,
          label: ( <MenuLabelWithBadge
          label={t('menu_40')}
          count={data?.cancelledCount}
        />),
        },
         {
          key: `${ORDER_MGNT}/${ORDERS}/${ORDER_STATUS.REFUND_ORDER}`,
          label: ( <MenuLabelWithBadge
          label={t("refunded_order")}
          count={data?.refundPendingCount}
        />),
        },
      ],
    },
    {
      key: DATA_MGNT,
      label: t('menu_41'),
      type: "group",
      children: [
        {
          key: `${DATA_MGNT}/${CATEGORIES}`,
          icon: <IconCategories />,
          label: t('menu_3'),
        },
        {
          key: `${DATA_MGNT}/${CATALOGUES}`,
          icon: <IconCatalogue />,
          label: t('menu_4'),
        },
         {
          key: `${DATA_MGNT}/${PRODUCT_OPTIONS}`,
          icon: <IconProducts />,
          label: t('product_options'),
        },
        {
          key: `${DATA_MGNT}/${BRAND}`,
          icon: <IconBrand />,
          label: t('menu_5'),
        },
        {
          key: `${DATA_MGNT}/${PRODUCTS}`,
          icon: <IconProducts />,
          label: t('menu_6'),
        },
        {
          key: `${DATA_MGNT}/${STOCK_MGNT}/all`,
          icon: <IconNoteSticky />,
          label: t('menu_7'),
        },
        {
          key: `${DATA_MGNT}/${STOCK_INVENTORY_REPORT}/all`,
          icon: <IconInventoryReport />,
          label: t('menu_8'),
        },
        {
          key: `${DATA_MGNT}/${USER_MANAGEMENT}`,
          icon: <IconUser />,
          label: t('menu_9'),
        },
        {
          key: `${DATA_MGNT}/${ADD_PACKAGE}`,
          icon: <IconAddPackage />,
          label: t('add_package'),
        },
      ],
    },
    {
      key: PAYMENT,
      label: t('menu_42'),
      type: "group",
      children: [
        {
          key: `${PAYMENT}/${PAYMENTAUTO}`,
          icon: <IconManualPayment />,
          label: t('menu_10'),
        },
         {
           key: `${PAYMENT}/${PAYMENTMANUAL}`,
           icon: <IconManualPayment />,
           label: t('menu_11'),
        },
         {
           key: `${PAYMENT}/${RECIVINGACCOUNT}`,
           icon: <RecivingAccount/>,
           label: t('menu_12'),
        },
         {
           key: `${PAYMENT}/${EXCHANGERATE}`,
           icon: <SwitchHorizontal />,
           label: t('menu_13'),
        },
         {
           key: `${PAYMENT}/${MAINTENANCE}`,
           icon: <IconInventoryReport />,
           label: t('menu_14'),
        },
      ],
    },
    {
      key: TEMPLATE_MGNT,
      label: t('menu_43'),
      type: "group",
      children: [
        {
          key: `${TEMPLATE_MGNT}/${TEMPLATE}`,
          icon: <IconTemplate />,
          label: t('menu_15'),
        },
        {
          key: SETTINGS,
          icon: <IconSettings />,
          label: t('menu_17'),
          children: [
            {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${BUSINESS_INFORMATION}`,
              icon: <IconBusinessInfo />,
              label: t('menu_18'),
            },
             {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${WELCOME_MESSAGE}`,
              icon: <IconTerms />,
              label: t('menu_20'),
            },
            {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${TERMS_CONDITIONS}`,
              icon: <IconTerms />,
              label: t('menu_21'),
            },
            {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${PAYMENT_TERMS_CONDITIONS}`,
              icon: <IconTerms />,
              label: t('menu_22'),
            },
            // {
            //   key: `${TEMPLATE_MGNT}/${SETTINGS}/${PAYMENT_METHODS}`,
            //   icon: <IconPayment />,
            //   label: "Payment Methods",
            // },
            // {
            //   key: `${TEMPLATE_MGNT}/${SETTINGS}/${DELIVERY_AREA}`,
            //   icon: <IconDelivery />,
            //   label: "Delivery Area",
            // },
            // {
            //   key: `${TEMPLATE_MGNT}/${SETTINGS}/${DELIVERY_AREA_TERMS}`,
            //   icon: <IconTerms />,
            //   label: "Delivery Terms & Conditions",
            // },
            {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${CUSTOMER_LOGIN_METHODS}`,
              icon: <IconLock />,
              label: t('menu_25'),
            },
            {
              key: `${TEMPLATE_MGNT}/${SETTINGS}/${CANCEL_REASON}`,
              icon: <IconTerms />,
              label: t('menu_26'),
            },
          ],
        },
      ],
    },
    {
      key: ADMINS,
      label: t('menu_44'),
      type: "group",
      children: [
        {
          key: ADMINS,
          icon: <IconAdmins />,
          label: t('menu_27'),
        },
      ],
    },
    {
      key: REPORTS,
      label: t('menu_45'),
      type: "group",
      children: [
        {
          key: REPORTS,
          icon: <IconReports />,
          label: t('menu_28'),
          children: [
            {
              key: `${REPORTS}/${PAYMENTREPORT}`,
              icon: <IconPaymentReport />,
              label: t('menu_29'),
            },
            {
              key: `${REPORTS}/${WITHDRAWREPORTS}`,
              icon: <IconWithdrawReport />,
              label: t('withdraw_report'),
            },
            {
              key: `${REPORTS}/${ADMIN_REPORT}/MERCHANT_ADMIN`,
              icon: <IconAdminReport />,
              label: t('menu_31'),
            },
            {
              key: `${REPORTS}/${USER_REPORT}`,
              icon: <IconCustomerReport />,
              label: t('menu_32'),
            },
            {
              key: `${REPORTS}/${INCOME_REPORT}/daily`,
              icon: <IconOrderReport />,
              label: t('menu_33'),
            },
            {
              key: `${REPORTS}/${PROFIT_REPORT}/daily`,
              icon: <IconProfitIcon />,
              label: t('profit_report'),
            },
            {
              key: `${REPORTS}/${ITEMS_PROFIT}`,
              icon: <IconItemProfit />,
              label: t('items_profit_report'),
            },
            {
              key: `${REPORTS}/${ORDER_REPORT}/daily`,
              icon: <IconIncomeReport />,
              label: t('menu_34'),
            },
             {
              key: `${REPORTS}/${OPT_USAGE_REPORT}`,
              icon: <LineChartOutlined />,
              label: t('menu_35'),
            },
          ],
        },
      ],
    },
  ];

  // const filterOptions = () => {
  //   if (!role) return [];

  //   switch (role) {
  //     case "MERCHANT_ADMIN":
  //       return allOptions;
  //     case "ORDER_ADMIN":
  //       return allOptions.filter(
  //         (opt) => opt.key === DASHBOARD || opt.key === ORDER_MGNT
  //       );
  //     case "DATA_ENTRY_ADMIN":
  //       return allOptions.filter(
  //         (opt) => opt.key === DASHBOARD || opt.key === DATA_MGNT
  //       );
  //     case "TEMPLATE_ADMIN":
  //       return allOptions.filter(
  //         (opt) => opt.key === DASHBOARD || opt.key === TEMPLATE_MGNT
  //       );
  //     default:
  //       return [];
  //   }
  // };

  const filterOptions = () => {
    if (!role) return [];

    switch (role) {
      case "MERCHANT_ADMIN":
        return allOptions;
      case "ORDER_ADMIN":
        return allOptions.filter(
          (opt) => opt.key === DASHBOARD || opt.key === ORDER_MGNT
        );
     case "DATA_ENTRY_ADMIN":
          return allOptions
            .filter(
              (opt) =>
                opt.key === DASHBOARD ||
                opt.key === DATA_MGNT ||
                opt.key === TEMPLATE_MGNT
            )
            .map((opt) => {
              if (opt.key === TEMPLATE_MGNT) {
                return {
                  ...opt,
                  children: opt.children?.filter(
                    (child) => child.key === SETTINGS
                  ),
                };
              }

              return opt;
            });
      case "TEMPLATE_ADMIN":
        return allOptions.filter(
          (opt) => opt.key === DASHBOARD || opt.key === TEMPLATE_MGNT
        );
      default:
        return [];
    }
  };

  // const options = allOptions;
  const options = filterOptions();
  const getOption = (items, path) => {
    return items.filter((opt) => opt.key?.includes(path));
  };
  
  const getPath = () => {
    return getOption(options, path1).map((opt) => opt.label);
  };

  const getSubpath = () => {
    const children = options
      .filter((opt) => opt.key === path1 && opt.children)
      .map((opt) => opt.children)[0];
    if (children) {
      return getOption(children, path2).map((subOpt) => subOpt.label);
    }
    return "";
  };

  const getIcon = () => {
    return getOption(options, path1).map((opt) => opt.icon)[0];
  };

  const defaultOpenKeys = () => {
    return options
      .filter((option) => option.children && option.key === path1)
      .map((opt) => opt.key);
  };

  const defaultSelectedKeys = () => {
    let openKey = defaultOpenKeys()[0];
    if (openKey) {
      let subOptions = options
        .filter((opt) => opt.key === openKey)
        .map((opt) => opt.children)[0];
      return subOptions
        .filter((opt) => opt.key.includes(path2))
        .map((opt) => opt.key);
    } else {
      return options.filter((opt) => opt.key === path1).map((opt) => opt.key);
    }
  };

  return {
    options,
    path: getPath(),
    subpath: getSubpath(),
    icon: getIcon(),
    defaultOpenKeys: defaultOpenKeys(),
    defaultSelectedKeys: defaultSelectedKeys(),
  };
};

export default useOptions;
